import { http } from '@/lib/http'
import snakecaseKeys from 'snakecase-keys'

export type DojouMeshParams = {
  baseTime: string
  forecastTime: string
  area: string
}

export class GpvRepository {
  async getTime() {
    const response = await http.get('/gpv/time')

    return response.data
  }

  async getDojouMesh(params: DojouMeshParams) {
    const response = await http.get('/gpv/dojou_mesh', { params: snakecaseKeys(params) })

    return response.data
  }
}
